<script setup lang="ts">
import { computed } from 'vue';

import { downloadAttachmentByUrl } from '../../lib';
import { MessageAttachmentType, type MessageInfoSchemaType } from '../../model';
import { MessageAttachmentPopupTemplate } from './templates';

const opened = defineModel<boolean>('opened', { default: false });

const { attachment } = defineProps<{
  attachment: NonNullable<MessageInfoSchemaType['attachments']>[number] | null;
}>();

const isImageAttachment = computed<boolean>(() => attachment?.type === MessageAttachmentType.IMAGE);

const close = () => {
  opened.value = false;
};

const downloadAttachment = async () => {
  if (!attachment) {
    return;
  }

  await downloadAttachmentByUrl(attachment.url, attachment.originalName);
};
</script>

<template>
  <MessageAttachmentPopupTemplate
    v-model:opened="opened"
    :attachment="attachment"
    :is-image-attachment="isImageAttachment"
    @close="close"
    @download="downloadAttachment"
  />
</template>
